var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [_c("router-view")], 1)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js?{"compilerOptions":{"preserveWhitespace":false},"extractCSS":true}!./node_modules/vue-loader/lib?{"compilerOptions":{"preserveWhitespace":false},"extractCSS":true}!./src/App.vue?vue&type=template&id=7ba5bd90&
// module id = 30
// module chunks = 5